import { useHub } from "@/components/AppShell";
import { PageHeader } from "@/components/common";
import { GiftCard } from "@/components/billing/GiftCard";

export default function GiftPage() {
  const { hub, reloadHub } = useHub();
  return (
    <div data-testid="gift-page">
      <PageHeader eyebrow="My account" title="Gift a year" rgb="var(--glow-family)" testid="gift-title" />
      <GiftCard hubId={hub.id} onGifted={reloadHub} />
    </div>
  );
}
